import * as oidc from 'oidc-client-ts';
import { useCallback, useEffect } from 'react';

export default function Component() {
  const load = useCallback(() => {
    window.location.hash = decodeURIComponent(window.location.hash);

    const mgr = new oidc.UserManager({
      authority: `https://parcel2go.test.p2g.ninja/auth`,
      client_id: 'smartsend.cs',
      loadUserInfo: true,
      redirect_uri: ''
    });

    mgr.signinSilentCallback().catch((error) => {
      console.error(error);
    });
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return <>Loading...</>;
}

Component.displayName = 'Silent';
